<div style="display:inline-block; margin:0px; padding:0px; height:25px;">
	<span *ngIf="targetType==='select'" (click)="select()" role="button"><i class="icnCircleCheck"></i></span>
	<span *ngIf="targetType==='learnMore'" (click)="select()" role="button"><i class="icnCircleInfo"></i></span>
	<span *ngIf="targetType==='map'" (click)="select()" role="button">
		<app-map-icon [mapObjectId]="normalizedData.MapObjectId" [enable]="normalizedData.onMap" [hasMany]="true"></app-map-icon>
	</span>
	<span *ngIf="targetType==='journey'" (click)="select()" role="button">
		<app-journey-icon [mapObjectId]="normalizedData.MapObjectId" [journeyable]="normalizedData.Journeyable" [hasMany]="true"></app-journey-icon>
	</span>
</div>
